/** How the correction mat presents: shown under the world, hidden, or disabled for the page. */
export enum EMatMode {
  MAT_UNDER = "MAT_UNDER",
  NO_MAT = "NO_MAT",
  MAT_DISABLED = "MAT_DISABLED",
}
